var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Const } from './provider/lib/const.cls';
import { mapActions } from 'vuex';
import { depositWithdrawal } from './lib/depositWithdrawal.cls';
import * as depositWithdrawalStoreExtensions from './provider/';
var state = __assign({}, depositWithdrawalStoreExtensions.stateExt);
var actions = __assign({}, depositWithdrawalStoreExtensions.actionsExt);
var mutations = __assign({}, depositWithdrawalStoreExtensions.mutationsExt);
var getters = __assign({}, depositWithdrawalStoreExtensions.gettersExt);
// new store module definition
var depositWithdrawalStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
// main mixin to load the new store module
export var depositWithdrawalMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[depositWithdrawal.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(depositWithdrawal.STORE_MODULE_NAME, depositWithdrawalStore);
            }
            catch (error) { }
        }
    },
    methods: __assign(__assign({}, mapActions({
        // _runGetPaymentMethods						: 			Const.RUN_GET_PAYMENT_METHODS,
        _runDemoDeposit: Const.RUN_DEMO_DEPOSIT,
        _runGetUserCanDeposit: Const.RUN_GET_USER_CAN_DEPOSIT,
        _runCreditCardDeposit: Const.RUN_CREDIT_CARD_DEPOSIT,
        _runGetWithdrawalMethods: Const.RUN_GET_WITHDRAWAL_METHODS,
        _runGenerateWalletAddress: Const.RUN_GENERATE_WALLET_ADDRESS,
        _runTransactionLimitCurrency: Const.RUN_TRANS_LIMIT_CURRENCY,
        _runWithdrawalRequestOtp: Const.RUN_WITHDRAWAL_REQUEST_OTP,
        _runWithdrawalCheckOtp: Const.RUN_WITHDRAWAL_CHECK_OTP,
        _runResendEmailLink: Const.RUN_RESEND_EMAIL_LINK,
        _runGetWithdrawalDesc: Const.RUN_GET_WITHDRAWAL_DESC,
        _runGetDepsitList: Const.RUN_GET_DEPOSIT_LIST,
        _runGetWithdrawalList: Const.RUN_GET_WITHDRAWAL_LIST,
        _runGetWithDepoCurList: Const.RUN_GET_WITH_DEPO_CUR_LIST,
        _runGetBankDetails: Const.RUN_GET_BANK_DETAILS,
        _runAddBankDetails: Const.RUN_ADD_BANK_DETAILS,
        _runEditBankDetails: Const.RUN_Edit_BANK_DETAILS,
        _runFiatWithdrawalRequestOtp: Const.RUN_FIAT_WITHDRAWAL_REQUEST_OTP,
        _runFiatWithdrawalRequestResendOtp: Const.RUN_FIAT_WITHDRAWAL_REQUEST_RESEND_OTP,
        _runFiatWithdrawalRequest: Const.RUN_FIAT_WITHDRAWAL_REQUEST,
        _runDeletePaymentMethod: Const.RUN_DELETE_PAYMENT_METHOD
    })), { computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        } }),
    computed: {
        getBankData: function () { return this.computedCommonFunc(Const.GET_BANK_DETAILS); },
        //deposit
        generateWalletAddress: function () { return this.computedCommonFunc(Const.GET_GENERATE_WALLET_ADDRESS); },
        withdrawalMethodResponse: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE); },
        withdrawalMethodResponseDep: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP); },
        // GetPaymentMethods: function(){ return this.computedCommonFunc(Const.GET_PAYMENT_METHODS); },
        deposit_limit: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIMIT); },
        depsitList: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIST); },
        depositStatus: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_Status); },
        withdrawalList: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_LIST); },
        withDepoCurList: function () { return this.computedCommonFunc(Const.GET_WITH_DEPO_CUR_LIST); },
    }
};
export default depositWithdrawalMixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/depositWithdrawal/index.ts
// module id = null
// module chunks = 